module dm.portal.services {

    export class ChangePasswordModalController {
        constructor(
            private modalScope: IChangePasswordModalControllerScope,
            private $window: ng.IWindowService,
            private userService: IUsersService,
            private oldPassword: string,
            private reason: string) {

            modalScope.state = {
                submitting: false,
                submitted: false,
                wasOldPasswordPassedIn: Boolean(oldPassword)
            };

            modalScope.errorMessages = [];
            modalScope.successMessages = [];
            modalScope.oldPassword = oldPassword;
            modalScope.message = reason;

            modalScope.modal = {
                cancel: this.cancelClick.bind(this),
                ok: this.okClick.bind(this),
                submit: this.submitClick.bind(this)
            };
        }

        cancelClick = () => {
            // Unresolved modal promise
            this.modalScope.$dismiss();
        }

        okClick = () => {
            if (this.modalScope.state.wasOldPasswordPassedIn) {
                this.modalScope.$close(this.modalScope.newPassword);
            } else {
                this.modalScope.$close();
                // resolved modal promise
                this.$window.location.reload(); // Requires full reload to get new user ticket query string
            }
        }

        submitClick = () => {
            this.modalScope.errorMessages = [];

            // Catch the client side validation problems right here. Let the server catch the only
            // remaining validation, which is "hey dummy that's not your old password".
            // Check *all* possible errors and display multiple problems, that should make the user's job easier.
            // NOTE: these message were taken directly from the CMC with no additional thought, grammar, or word-smithing (russg 12/2015)
            //
            if (!this.modalScope.oldPassword) {
                this.modalScope.errorMessages.push("Your Old Password may not be blank");
            }
            if (!this.modalScope.newPassword) {
                this.modalScope.errorMessages.push("Your New Password may not be blank");
            }
            if (!this.modalScope.confirmPassword) {
                this.modalScope.errorMessages.push("Your Confirm Password may not be blank");
            }
            if (this.modalScope.oldPassword && this.modalScope.newPassword && (this.modalScope.oldPassword == this.modalScope.newPassword)) {
                this.modalScope.errorMessages.push("Your New Password must be different from your Old Password");
            }
            if (this.modalScope.newPassword && this.modalScope.confirmPassword && (this.modalScope.newPassword != this.modalScope.confirmPassword)) {
                this.modalScope.errorMessages.push("Your New Password must match the Confirmation Password");
            }
            if (this.modalScope.newPassword) {
                // This function appends error messages to the second parameter as a side effect
                this.weakPasswordCheck(this.modalScope.newPassword, this.modalScope.errorMessages);
            }

            // Jury is out, some good reasons to clear all, some downside too; could be *way* more granular-selective about resetting
            if (this.modalScope.errorMessages.length > 0) {
                if (!this.modalScope.state.wasOldPasswordPassedIn) { // as far as changing, if it was a temp password, don't reset to null.
                    this.modalScope.oldPassword = null;
                }
                this.modalScope.newPassword = null;
                this.modalScope.confirmPassword = null;
                this.modalScope.state.submitting = false;
                return;
            }

            // implied else, returned directly from 'if' above
            this.modalScope.state.submitting = true;

            this.userService.changePassword(this.modalScope.oldPassword, this.modalScope.newPassword)
                // success handler - always used, the 'response' value tells us what really happened
                .then((response) => {
                    this.modalScope.state.submitting = false;
                    if (response === true) {
                        this.modalScope.successMessages.push("Your password has been successfully changed");
                        this.modalScope.state.submitted = true;
                    }
                    else {
                        this.modalScope.errorMessages.push("Your password has not been changed.  Please ensure that you have entered your current password correctly.");
                        if (!this.modalScope.state.wasOldPasswordPassedIn) { // as far as changing, if it was a temp password, don't reset to null.
                            this.modalScope.oldPassword = null;
                        }
                        this.modalScope.newPassword = null;
                        this.modalScope.confirmPassword = null;
                        this.modalScope.state.submitted = false;
                    }
                });
        }

        // password - is a String
        // messages - is a String array
        // considered returning 'false' on failure(s), not done yet, not needed
        //
        private weakPasswordCheck = (password: string, messages: string[]): void => {
            var lowerCase = /[a-z]/;
            var upperCase = /[A-Z]/;
            var digit = /[0-9]/;

            if ((password.length < 8) || (password.length > 31)) {
                messages.push("Your New Password must be between 8 and 31 characters long");
            }
            if (password.search(lowerCase) < 0) {
                messages.push("Your New Password must contain at least one lower case letter");
            }
            if (password.search(upperCase) < 0) {
                messages.push("Your New Password must contain at least one upper case letter");
            }
            if (password.search(digit) < 0) {
                messages.push("Your New Password must contain at least one number");
            }
        }
    }
}